module.exports = __webpack_public_path__ + "static/handheld_scanner-07fe1e6d4fc07af017faa9f092ba13a6.webp";